<template>
  <div>
    <coolgua-container>
      <div class="flex-c-c " style="position: relative;justify-content:space-between">
        <div class="flex">
          <div
            @click="go2home"
            class="logo" style="display: flex;justify-content:center;align-items: center">
              <el-image :src="index.activity.logoUrl || 'https://coolgua-dev.oss-cn-beijing.aliyuncs.com/logo.png'" :alt="index.activity.name" style="height:47px;width:216px;" fit="fill" slot="error" />
              <!-- <el-image src="https://coolgua-dev.oss-cn-beijing.aliyuncs.com/logo.png" alt="西部文博会云展" style="width:110px;height:110px" fit="fill" /> -->
            <span style="font-size: 22px;font-weight: bold;letter-spacing: 3px; color: #fff; padding-left: 50px;max-width: 370px;"> {{index.activity.name}}</span>
          </div>
          <!-- <div class="flex flex-c-c flex-c" style="margin-left: 32px;">
             <div class="button1 button11" @click="go2Exhibitor">展商入口</div>
             <div class="button1 button22 " @click="go2Audience">观众入口</div>
           </div>-->
          <!--登陆的信息-->
          <!-- <div style="margin-left: 32px;position: relative;top: 18px;" class="flex " > -->
          <div style="margin-left: 32px;color: #fff; " class="flex user-info">
            <!-- <span class="primary-color">{{getNickName}}</span> -->
            <!--            userList?(userList.contact==""?userList.company:userList.contact):"-->
            <span class="">{{getNickName}}</span>
            <!--            <span class="primary-color" v-else>{{userList.contactEn == "" ? email : userList.contactEn
            }}</span>-->
            <span style="padding-left: 10px;color: #FFF;cursor: pointer" @click="logout" v-if="getNickName">[{{$t('lang.退出')}}]</span>
          </div>
        </div>
        <div class="flex">
          <div class="flex-c-c flex-c" v-if="loginUser && islogin">
            <div class="wrapperName ">
              <i class="iconfont icon-shuangjiantouyou"></i>
              <span :class="['nameEn pointer']"
                    @click="linkToMyAccount">{{$t('lang.个人中心')}}</span>
              <i class="iconfont icon-shuangjiantouzuo"></i>
            </div>
          </div>
          <div class="flex-c-c flex-c" v-else>
            <div class="wrapperName ">
              <i class="iconfont icon-shuangjiantouyou"></i>
              <span :class="['nameEn pointer islogin']"
                    @click="loginShow">{{$t('lang.登录')}}</span>
              <i class="iconfont icon-shuangjiantouzuo"></i>
            </div>
          </div>
          <!-- <div class="ChineseEnglish" style="margin-left: 30px;">
            <div style="width: 35px;height: 35px;cursor: pointer;" class="font " @click="()=>switchLang('zh')"
                 :class="[g.lang=='zh'?'primary':'line']">中
            </div>
            <div style="width: 35px;height: 35px;cursor: pointer;" class="font " @click="()=>switchLang('en')"
                 :class="[g.lang=='en'?'primary':'line']"
            >EN
            </div>
          </div> -->
        </div>

      </div>
    </coolgua-container>
  </div>
</template>
<script>
  import navHeaderMatch from '@match/components/navHeader/index'

  import {computedIndex, go2Audience, go2Exhibitor, go2home, logout} from "../utils";
  import {
    createA,
    getCookie,
    getLoginUser,
    getNickName,
    getProjectId,
    getUrlParamNative,
    jsonParseSafe, params2url,
    setCookie,
    getUserRoleType
  } from "@common/utils";
  import { type_src_supplier } from "@common/constact";
  import myalert from "@common/utils/myalert";
  import *  as routerUtil from '@common/utils/routerUtil';
  import {isShengzheng} from "../constants";
  import bus from '@common/bus'

  export default {
    "nanme": "nav-header",
    data() {
      return {
        isShengzheng,
        mobilePhone: '', ImproveIn: false, email: '',
        userList: {},
        loginshow:true,
        loginUser: typeof getLoginUser() == 'object' ? Object.keys(getLoginUser()).length == 0 ? '' : getLoginUser() : getLoginUser()
      }
    },
    computed: {
      getNickName() {
        if (!getLoginUser()) {
          return ''
        }
        var user = jsonParseSafe(getLoginUser())
        try {
          var user = jsonParseSafe(getLoginUser());
        } catch(e) {
          var user = getLoginUser()
        }
        console.log('user', user)
        let contactInformation =null;
        if(user){
          contactInformation = user.mobilePhone || user.email
        }
        // if (!user) return "";
        if (user && user.user2src == type_src_supplier) {
          // return this.g.isEn ? (user.companyEn  ||  contactInformation): (user.company || contactInformation )
          return contactInformation
        } else {
          //如果是观众
          return this.g.isEn ? (user.contactEn  || contactInformation ) : (user.contact || contactInformation )
        }
      },
      index() {
        return computedIndex.call(this)
      },
      isEn() {
        return getCookie('lang')
      },
      islogin() {
        return getCookie("login")
      }
    },
    mounted() {
      var  user= jsonParseSafe(getLoginUser())
      this.mobilePhone = user&&user.mobilePhone
      this.email = user&&user.email
      this.ImproveInformation();
    },
    methods: {
      // 登录弹窗出现
      loginShow() {
        console.log(this.$route.path.indexOf('login'))
        if(this.$route.path.indexOf('login') < 0) {

          this.$router.push(`/login/?projectId=${getProjectId()}`)
        }
        bus.$emit('getonbus',this.loginshow)
      },
      // 判断是否完善个人信息
      ImproveInformation() {
        let user = jsonParseSafe(getLoginUser());
        this.userList = user;
        console.log('userList=======>', this.userList);
        for (let item in user) {
          if (!item) {
            this.ImproveIn = false;
          }
        }
      },
      switchLang(lang) {
        if (!lang) {
          //如果路径没有 就从cookie拿
          lang = getUrlParamNative('lang')||getCookie('lang') || 'zh'
        }
        setCookie("lang", lang)
        sessionStorage.setItem("matchCgsType", "")
        this.$i18n.locale = lang;//改变当前语言
        location.href=`${location.origin}?${params2url({
          projectId:getProjectId(),
          lang,
        })}`;
      },
      go2home: go2home.bind(this),
      go2Exhibitor: go2Exhibitor.bind(this),
      go2Audience: go2Audience.bind(this),
      go2other(str) {
        // if (str == this.$t('lang.前往深圳展')) {
        //   createA(`https://live.ledChina.com/pc/?lang=${this.g.isEn?'en':'zh'}`)
        //   return false;
        // } else {
          /*
            替换链接
            英文版改：LED CHINA Website 为链接去官网： https://www.ledchina.com/en/
            中文版改：大会官网 为链接去官网：https://www.ledchina.com/
            * */
          if(this.g.isEn){
            createA(`https://www.ceramicschina.net/`)
            return false
          }else{
            createA(`https://www.ceramicschina.net/`)
            return false
          }

        // }
      },
      logout() {
        var self = this;
        myalert.confirm(this.$t('lang.确定要退出吗')).then(isyes => {
          if (isyes) {
            setCookie("login", '')
            logout()
          }
        })
      },
      linkToMyAccount() {
        var userType = getUserRoleType()
        if (userType == type_src_supplier) {
          routerUtil.push(`/me/exhibition`);
        } else {
          routerUtil.push(`/me/purchaser`);
        }
      }
    }
  }
</script>
<style scoped lang="less">
  @import '../styles/color';

  .primary-color {
    color: @primaryColor;
  }

  .button1 {
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;

    &.button11 {
      background: @primaryColor;
      color: #fff;
      font-size: 18px;
      height: 30px;
      width: 118px;
    }

    &.button22 {
      background: @blue1;
      color: #fff;
      font-size: 18px;
      margin-left: 10px;
      height: 30px;
      width: 118px;
    }
  }

  .user-info {
    align-items: center;
  }

  .wrapperName {
    .name {
      color: @primaryColor;
      padding-left: 0px;
      padding-right: 0px;
      font-size: 19px;
      font-weight: bold;
    }

    .nameEn {
      color: #fff;
      padding-left: 0px;
      padding-right: 0px;
      font-size: 19px;
      font-weight: bold;
    }

    .iconfont {
      color: #fff;
      font-size: 21px;
    }
  }

  .ChineseEnglish {
    display: inline-flex;

    .primary {
      width: 35px;
      height: 35px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      background: @primaryColor;
      color: #fff;
    }

    .line {
      width: 35px;
      height: 35px;
      background: #fff;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border: 1px solid @primaryColor;
      color: @primaryColor;
      // margin-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/wenxing/components/navHeader.vue